import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 're-configuration-delete-confirmation-dialog',
    templateUrl: './configuration-delete-confirmation-dialog.component.html',
    styleUrls: ['./configuration-delete-confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfigurationDeleteConfirmationDialogComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit(): void {
  }


  deleteConfiguration() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

}
